import React, { useState } from 'react';
import './Collection.css';
// import img11 from "../Image/img11.jpg"
import img12 from "../Image/img12.jpg"
import img13 from "../Image/img13.jpg"
import img14 from "../Image/img14.jpg"
import img15 from "../Image/img15.jpg"
import img16 from "../Image/img16.jpg"
import img17 from "../../assets/images/in.jpg"
import img18 from "../../assets/images/in1.jpg"
import img19 from "../Image/IMG_6587[1].jpg"
import TestimonialsGrid from '../TestimonialsGrid';


// Placeholder images - replace with your actual image paths
const imagePaths = [
// img11,
img13,
img12,

img14,
img15,
img16,
img17,
img18,
img19
];

const Collection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
   
    <div className="gallery-container">
    <h1 className='Gallery'>Our Gallery</h1>
      <div className="image-grid">
        {imagePaths.map((path, index) => (
          <div 
            key={index} 
            className="image-wrapper"
            onClick={() => setSelectedImage(path)}
          >
            <img 
              src={path} 
              alt={`Gallery image ${index + 1}`}
              className="gallery-image"
            />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="modal-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <div className="modal-content">
            <img 
              src={selectedImage}
              alt="Enlarged view"
              className="modal-image"
            />
          </div>
        </div>
      )}
    </div>
  
    <TestimonialsGrid/>
    </>
  );
};

export default Collection;